import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { useFileVersions } from "../../../../../hooks/useFileVersions"
import { DimaFeatureShortNameEnum } from "../../../../models/Authorization"
import { FileVersionGet } from "../../../../models/FileVersion"
import { deleteEntity } from "../../../../utils/deleteEntity"
import {
  dateStringComparator,
  getNiceFormattedDate,
} from "../../../../utils/getFormattedDate"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function FileVersions() {
  const { fileId } = useParams()
  const { fileVersions, isLoadingFileVersions } = useFileVersions(fileId)
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: `/files/${fileId}/versions`,
    },
    {
      field: "uploadDate",
      headerName: "Upload Date",
      sortComparator: dateStringComparator,
    },
    { field: "uploadedBy", headerName: "Uploaded By" },
  ]

  const sorted = [...fileVersions].sort(
    (a, b) =>
      new Date(b.uploadDate ?? 0).getTime() - new Date(a.uploadDate ?? 0).getTime()
  )

  const rows = sorted.map((fileVersion: FileVersionGet) => ({
    id: fileVersion.id,
    name: `${fileVersion.file.name}${fileVersion.suffix ?? ""}.${
      fileVersion.file.extension
    }`,
    uploadDate: getNiceFormattedDate(fileVersion.uploadDate),
    uploadedBy: fileVersion.uploadedBy.username,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/files/${fileId}/versions/create`}
        feature={DimaFeatureShortNameEnum.FM}
      />
    ),
    [fileId]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(`/files/${fileId}/versions/${row.id}`)
        )
      }
    }, [fileId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingFileVersions}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
